module.exports = __webpack_public_path__ + "img/icon-support-mail.ef76ed4f.svg";